<template>
  <!-- 创建录入信息 -->
  <div class="add-group-wrapper">
    <el-dialog
            :visible.sync="isShow"
            width="500px"
            :title="isEdit ? '编辑录入信息' : '创建录入信息'"
            :close-on-click-modal="false"
            custom-class="add-sup-group"
    >
      <div class="scroll-wrapper">
        <vue-scroll :ops="ops">
          <div class="form-wrapper">
            <el-form
                    v-if="!loading"
                    ref="addRecord"
                    :model="recordForm"
                    :rules="recordRules"
                    label-width="110px"
            >

              <el-form-item label="输送记录名称" prop="recordName">
                <el-input
                        v-model="recordForm.recordName"
                        placeholder="请输入输送记录名称"
                        class="yioks-w100"
                ></el-input>
              </el-form-item>

              <el-form-item label="请选择年份" prop="recordYear">
                <el-date-picker
                        v-model="recordForm.recordYear"
                        type="year"
                        placeholder="请选择年份"
                        class="yioks-w100"
                        value-format="yyyy"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item label="是否开启填报" prop="open">
                <el-switch
                    v-model="recordForm.open"
                    active-color="#13ce66"
                    inactive-color="#ccc"
                    active-text="开启"
                    inactive-text="关闭"
                ></el-switch>
              </el-form-item>
              <fieldset v-if="recordType === 'match'" class="vita-form-fieldset">
                <legend>组别配置</legend>
                <el-row v-for="(item, index) in recordForm.recordToSquadList" :key="index"
                        style="display: flex">
                  <div>
                    <el-form-item
                            :label="`球队性质${index + 1}`"
                            :prop="`recordToSquadList.${index}.squadSex`"
                            :rules="[{ required: true, message: '信息不能为空', trigger: 'blur' }]"
                    >
                      <el-select
                              v-model="item.squadSex"
                              placeholder="请选择球队性质"
                              class="yioks-w75">
                        <el-option
                                v-for="(item,index) in squadSexList1"
                                :key="index"
                                :label="item.value"
                                :value="item.key"/>
                      </el-select>

                    </el-form-item>

                    <el-form-item
                            :label="`球队级别${index + 1}`"
                            :prop="`recordToSquadList.${index}.squadLevel`"
                            :rules="[{ required: true, message: '信息不能为空', trigger: 'blur' }]"
                    >
                      <el-input
                              v-model="item.squadLevel"
                              placeholder="请输入球队级别"
                              class="yioks-w75"
                      ></el-input>

                    </el-form-item>
                  </div>
                  <div class="action-wrapper">
                    <div
                            v-if="recordForm.recordToSquadList.length - 1 === index"
                            class="action-icon add-icon"
                            @click="handleAddSquad"
                    >
                      <i class="el-icon-circle-plus-outline"></i>
                    </div>
                    <div
                            v-if="recordForm.recordToSquadList.length > 1"
                            class="action-icon delete-icon"
                            @click="handleDeleteSquad(index)"
                    >
                      <i class="el-icon-remove-outline"></i>
                    </div>
                  </div>
                </el-row>
              </fieldset>

              <fieldset class="vita-form-fieldset">
                <legend>名次配置</legend>
                <el-row v-for="(item, index) in recordForm.recordToScoreList" :key="index"
                        style="display: flex">
                  <div>
                    <el-form-item
                            :label="`名次/人次${index + 1}`"
                            :prop="`recordToScoreList.${index}.ranking`"
                            :rules="[{ required: true, message: '信息不能为空', trigger: 'blur' }]"
                    >
                      <el-input-number
                              v-model="item.ranking"
                              :min="0"
                              label="请输入比赛球队名次或集训人次"
                              class="yioks-w76"
                      ></el-input-number>

                    </el-form-item>

                    <el-form-item
                            :label="`分值${index + 1}`"
                            :prop="`recordToScoreList.${index}.score`"
                            :rules="[{ required: true, message: '信息不能为空', trigger: 'blur' }]"
                    >
                      <el-input-number
                              v-model="item.score"
                              :min="0"
                              label="请输入比赛球队名次分值或集训人次分值"
                              class="yioks-w76"
                      ></el-input-number>

                    </el-form-item>
                  </div>
                  <div class="action-wrapper">
                    <div
                            v-if="recordForm.recordToScoreList.length - 1 === index"
                            class="action-icon add-icon"
                            @click="handleAddScore"
                    >
                      <i class="el-icon-circle-plus-outline"></i>
                    </div>
                    <div
                            v-if="recordForm.recordToScoreList.length > 1"
                            class="action-icon delete-icon"
                            @click="handleDeleteScore(index)"
                    >
                      <i class="el-icon-remove-outline"></i>
                    </div>
                  </div>
                </el-row>
              </fieldset>
            </el-form>
            <div v-if="!loading" class="tip">带 * 号的为必填项</div>
            <div v-if="!loading" class="dialog_btn_wrap">
              <el-button
                      type="primary"
                      style="margin-right:20px"
                      :loading="addbtnLoading"
                      @click="addRecord"
              >确认
              </el-button>
              <el-button type="danger" @click="isShow = false">取消</el-button>
            </div>
            <yioks-loading v-if="loading" style="height: 500px"/>
          </div>
        </vue-scroll>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {ops} from "@/utils/scrollIndialog";
import {squadSexList1} from '@/utils/yioks_data'
import {requiredItem} from "@/assets/js/formRules";
import record from '@/api/record'

export default {
  name: "AddSupGroup",

  props: {
    isShowDialog: {
      type: Boolean,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: false,
    },
    recordUuid: {
      type: String,
      required: false,
    },
    recordType: {
      type: String,
      required: false,
    },
  },

  computed: {
    isShow: {
      get() {
        return this.isShowDialog;
      },
      set(val) {
        this.$emit("hideAddRecordDialog", val, false);
      },
    },
  },

  data() {
    return {
      ops,
      squadSexList1,
      loading: false,
      addbtnLoading: false,
      recordForm: {
        open: true,
        recordYear: "",
        recordName: "",
        recordToSquadList: [ // 球队组别
          {
            squadSex: "",
            squadLevel: "",
            recordUuid: this.recordUuid,
          },
        ],
        recordToScoreList: [ // 得分
          {
            ranking: "",
            score: "",
            recordType: this.recordType,
            recordUuid: this.recordUuid,
          },
        ],
      },
      recordRules: {
        recordYear: [requiredItem("年份", true)],
        recordName: [requiredItem("输送记录名称")],
      },
    };
  },


  created () {
    if (this.isEdit && this.recordUuid) {
      this.getRecordInfo()
    }
  },

  methods: {
    // 编辑详情接口
    getRecordInfo() {
      this.loading = true
      record.getRecordInfo(this.recordUuid).then(res => {
        if (res.code) {
          this.$message.error(res.msg)
        }
        this.recordForm = res;
        this.loading = false;
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    },

    // 添加接口
    addRecord() {
      this.$refs['addRecord'].validate(valid => {
        if (valid) {
          this.addbtnLoading = true
          const { recordName, recordYear, open, recordToScoreList, recordToSquadList } = this.recordForm;

          let request = record.addRecord // 请求名
          let requestData = {
            recordName,
            recordYear:recordYear,
            open,
            recordType:this.recordType,
            recordToSquadList:this.recordType === 'match' ? recordToSquadList : [],
            recordToScoreList,
          }
          // 编辑球队时，data 加上 uuid，接口名改变
          if (this.isEdit) {
            request = record.editRecord // 请求名
            requestData.uuid = this.recordUuid
          }
          request(requestData).then(res => {
            this.addbtnLoading = false
            // 重复处理
            if (res.code) {
              this.$message.error(res.msg)
            } else {
              this.$emit('hideAddRecordDialog', false)
              if (!this.isEdit) {
                this.$router.push({
                  path: 'list'
                })
              }
            }

          }).catch(err => {
            this.addbtnLoading = false
            console.error(err)
          })
        }

      })
    },

    handleAddSquad() {
      const newSquad = {
        squadSex: "",
        squadLevel: "",
        recordUuid: this.recordUuid,
      };
      const {recordToSquadList} = this.recordForm;
      recordToSquadList.push(newSquad);
      this.$set(this.recordForm, "recordToSquadList", recordToSquadList);
    },
    handleDeleteSquad(index) {
      const {recordToSquadList} = this.recordForm;
      recordToSquadList.splice(index, 1);
      this.$set(this.recordForm, "recordToSquadList", recordToSquadList);
    },

    handleAddScore() {
      const newScore = {
        ranking: "",
        score: "",
        recordType: this.recordType,
        recordUuid: this.recordUuid,
      };
      const {recordToScoreList} = this.recordForm;
      recordToScoreList.push(newScore);
      this.$set(this.recordForm, "recordToScoreList", recordToScoreList);
    },
    handleDeleteScore(index) {
      const {recordToScoreList} = this.recordForm;
      recordToScoreList.splice(index, 1);
      this.$set(this.recordForm, "recordToScoreList", recordToScoreList);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.scroll-wrapper
  height 450px

.form-wrapper
  margin-right 30px

.yioks-w100
  width 100%

.yioks-w75
  width 100%

.yioks-w76
  width 90%

.vita-form-fieldset
  padding 10px 10px 0
  border 1px dashed #dcdfe6
  margin-bottom 20px

.action-wrapper
  display flex
  margin-bottom 10px
  align-items center

  .action-icon
    width 25px
    display flex
    align-items center
    justify-content center
    border-radius 50%
    height 35px
    color $color_white
    font-size 2em
    margin 0 5px
    cursor pointer
    user-select none

    &.add-icon
      color $green_color

    &.delete-icon
      color $orange_color

.btns-group
  display flex
  justify-content center
  margin 30px 0
</style>

<style lang="stylus">
.add-sup-group
  .el-dialog__header
    border-bottom 1px solid #666
    margin 0 20px
    padding-left 0

    .el-dialog__title
      font-weight normal
      font-size 20px
      color #666
</style>
